import { stimulusApplication } from 'lib/stimulus_app'
import RegistroController from 'lib/registro_controller'
import AnaliticaRegistroController from 'lib/analitica_registro_controller'

const application = stimulusApplication()
application.register('registro', RegistroController)
// Analítica del embudo de onboarding en `/registro` (TC-134-1.4.5.3). Se registra
// en el mismo pack que el formulario porque lo carga la misma pantalla y porque el
// controlador de página tiene que estar vivo antes que el del formulario.
application.register('analitica-registro', AnaliticaRegistroController)
